module.exports = __webpack_public_path__ + "media/images/countryrect/tk-574c85bd60f8789668f6469fa42deb0c.svg";